import { connect } from 'react-redux'
import ServiceViewProviders from '../../components/services/view/ServiceViewProviders'
import { IStoreState } from '../../types/index'
import { getServicesProducts } from '../../state/reducers/provider-products/index'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    serviceProducts: getServicesProducts(state, ownProps.serviceId)
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceViewProviders)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewProviders.ts